import { IonModal } from "@ionic/react";
import { useHistory } from "react-router";

import "../Attesa/attesa.style.css";

interface PrivacyModalProps {
  visible: boolean;
  onClose: () => void;
}

const CompleteProfileModal = ({ visible, onClose }: PrivacyModalProps) => {
  const history = useHistory();

  return (
    <IonModal
      isOpen={visible}
      swipeToClose={false}
      backdropDismiss={false}
      cssClass="small-modal"
    >
      <div className="modal-content">
        <h2 className="modal-title">Completa il tuo profilo</h2>
        <p className="modal-description">
          Non puoi confermare i preventivi senza aver completato il profilo.
          Completa i tuoi dettagli per procedere.
        </p>

        <div className="attesa-policy-buttons attesa-button-font">
          <button className="attesa-button-cancel" onClick={onClose}>
            Annulla
          </button>
          <button
            className="attesa-button-save"
            onClick={() => history.push("/personale/dati")}
          >
            Completa profilo
          </button>
        </div>
      </div>
    </IonModal>
  );
};

export default CompleteProfileModal;
